import ButtonGsfurn from "components/General/ButtonGsfurn/ButtonGsfurn";
import InputFieldGrinwis from "components/General/InputFieldGrinwis/InputFieldGrinwis";

const LoginForm = ({ infoText = false, onSubmit, dark = false }) => {
  return (
    <form
      className="flex flex-col gap-4"
      onSubmit={onSubmit}
    >
      <div className="flex gap-5">
        <InputFieldGrinwis
          label="Vul je e-mailadres in"
          name="email"
          dark={dark}
        />
        <ButtonGsfurn
          color="yellow_grw"
          size="xl"
          type="submit"
        >
          Inloggen
        </ButtonGsfurn>
      </div>
      {infoText && (
        <div className="mb-1">
          <p className="mb-0 text-dark-text">
            {infoText}
          </p>
        </div>
      )}
    </form>
  )
}

export default LoginForm;